import { Routes } from '@angular/router';
import { EC_GOODS_GRP_CONFIG } from './base/ec-goods-grp-config';

export const ecGoodsGrpRoutes: Routes = [
  {
    path: EC_GOODS_GRP_CONFIG.routePath,
    data: {
      title: 'EC 상품 그룹 관리',
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/ec-goods-grp-list-page/ec-goods-grp-list-page.component'
          ).then((m) => m.EcGoodsGrpListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/ec-goods-grp-detail-page/ec-goods-grp-detail-page.component'
              ).then((m) => m.EcGoodsGrpDetailPageComponent),
            data: {
              title: 'EC 상품 그룹 상세',
            },
          },
        ],
      },
    ],
  },
];
